<div class="container-simple-toggle" [ngClass]="{ 'inverted-label': invertLabel && !spaceBetween, 'space-between': spaceBetween }">
  <input
    [id]="inputId"
    class="js-structured-search-toggle"
    type="checkbox"
    style="display: none"
    (change)="handlerClick($event)"
    [checked]="checked"
    />

    <div class="simple-toggle" (click)="toggleInput()">
      <span class="ball"></span>
    </div>

    @if (label) {
      <label class="label" [for]="inputId">{{ label | cxTranslate }}</label>
    }
  </div>
